"use client";

import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import VideoModule from "@/components/VideoModule/VideoModule.component";
import { checkIfImage } from "@/lib/utils";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef } from "react";
import { TextOverAssetModel } from "./TextOverAsset.model";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, useGSAP);

const TextOverAsset = ({
  title,
  asset,
  videoUrl,
  showVideoControls = false,
}: TextOverAssetModel) => {
  const textOverAssetRef = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add(`(max-width: 767px)`, () => {
      ScrollSmoother.create({
        normalizeScroll: true,
      });
    });

    gsap.to("#textOverAsset__description", {
      scrollTrigger: {
        trigger: textOverAssetRef?.current,
        start: "top top",
        end: "+=100%",
        scrub: 1,
        pin: true,
        pinSpacing: false,
      },
    });
  }, []);

  return (
    <>
      <div
        ref={textOverAssetRef}
        className="textOverAsset relative z-10 col-span-12 grid h-screen w-full overflow-hidden"
      >
        {asset && !checkIfImage(asset?.contentType) && (
          <VideoModule
            className="h-screen w-screen object-cover"
            name={title}
            video={asset}
            showVideoControls={showVideoControls}
          />
        )}
        {asset && checkIfImage(asset?.contentType) && (
          <Image
            src={`${asset?.url}?fm=webp`}
            alt={title}
            width={asset?.width}
            height={asset?.height}
            className="h-screen w-screen object-cover"
          />
        )}
        {videoUrl && !asset && (
          <VideoModule
            name={title}
            videoUrl={videoUrl}
            showVideoControls={showVideoControls}
          />
        )}
      </div>
      <Typography.H1
        id="textOverAsset__description"
        className="text-core-white absolute bottom-0 left-0 z-20 w-full text-[72px] leading-[80%] tracking-tighter break-words hyphens-auto md:text-[240px]"
      >
        {title}
      </Typography.H1>
    </>
  );
};

export default TextOverAsset;
